import store from '@store'
import { categoryOptions, storeOptions } from "@utils/ipetbooking-options";
import { conditionList } from "@utils/is-condition";

export function mainMenuList() {
  // const isLoggedIn = store.getters['auth/isLoggedIn'];
  const isSiteEnabled = store.getters['merchant/isSiteEnabled'];
  const currentMerchant = store.state.merchant.currentMerchant;
  const components = currentMerchant.components;
  const isPrepaidEnabled = !!currentMerchant.prepaidSetting?.isEnabled ?? false;
  const hasDepositModule = !!currentMerchant.depositSetting?.isEnabled ?? false;
  const isMemberLevelEnabled = !!currentMerchant.levelSetting?.isEnabled ?? false;
  const storeOpenOptions = storeOptions({
    type: 'open'
  });

  return conditionList([
    {
      title: currentMerchant.cosmeticSetting.title || '線上預約',
      to: {
        name: 'reservation'
      },
      condition: () => {
        return !!storeOpenOptions[0] && !!currentMerchant.petCategories[0] && isSiteEnabled
      },
    },
    {
      title: currentMerchant.depositSetting?.title || '線上儲值',
      to: {
        name: 'deposit'
      },
      condition: () => {
        return !!storeOpenOptions[0]  && components.includes('deposit') && hasDepositModule
      },
      isLoginPage: true,
    },
    {
      title:`購買${currentMerchant.prepaidSetting.title || '包套方案'}`,
      to: {
        name: 'prepaid'
      },
      condition: () => {
        return !!storeOpenOptions[0] && !!currentMerchant.petCategories[0] && isPrepaidEnabled
      },
    },
    {
      title: currentMerchant.levelSetting?.title || '會員等級',
      to: {
        name: 'level'
      },
      condition: () => {
        return !!storeOpenOptions[0] && components.includes('memberlevel') && isMemberLevelEnabled
      },
    },
    {
      title: `使用${currentMerchant.prepaidSetting?.title ||'包套方案 '}`,
      type: 'prepaidReservation',
      to: {
        name: 'prepaid-reservation'
      },
      condition: () => {
        return !!storeOpenOptions[0] && !!currentMerchant.petCategories[0] && isSiteEnabled && isPrepaidEnabled
      },
    },
  ]);
}
export function mainMenuRightList() {
  const isLoggedIn = store.getters['auth/isLoggedIn'];

  return conditionList([
    {
      title: '結帳預約',
      type: 'cart',
      icon: 'fontello fontello-time',
      to: {
        name: 'reservation-checkout'
      },
    },
    {
      title: '登入 | 註冊',
      type: 'login',
      icon: 'fontello fontello-account',
      condition: () => {
        return !isLoggedIn
      },
    },
    {
      title: '',
      type: 'member',
      icon: 'fontello fontello-account',
      to: {
        name: 'member'
      },
      condition: () => {
        return isLoggedIn
      },
    },
  ]);
}
export function jtailsMainMenuList() {
  // const isSiteEnabled = store.getters['merchant/isSiteEnabled'];
  const currentMerchant = store.state.merchant.currentMerchant;
  const components = currentMerchant.components;
  const isPrepaidEnabled = !!currentMerchant.prepaidSetting?.isEnabled ?? false;
  const hasDepositModule = !!currentMerchant.depositSetting?.isEnabled ?? false;
  const isMemberLevelEnabled = !!currentMerchant.levelSetting?.isEnabled ?? false;
  const storeOpenOptions = storeOptions({
    type: 'open'
  });

  return conditionList([
    {
      title: '店面服務',
      icon: 'fontello fontello-shop',
      type: 'lightbox',
      data: 'store',
      condition: () => {
        return !!storeOpenOptions[0] && !!currentMerchant.petCategories[0] 
      },
    },
    {
      title: '到府服務',
      icon: 'fontello fontello-house',
      type: 'lightbox',
      data: 'home',
      condition: () => {
        return !!storeOpenOptions[0] && !!currentMerchant.petCategories[0]
      },
    },
    {
      title: currentMerchant.prepaidSetting?.title ||'包套方案',
      icon: '',
      type: 'link',
      to: {
        name: 'prepaid'
      },
      condition: () => {
        return !!storeOpenOptions[0] && !!currentMerchant.petCategories[0] && isPrepaidEnabled
      },
    },
    {
      title: currentMerchant.levelSetting?.title || '會員等級',
      to: {
        name: 'level'
      },
      condition: () => {
        return !!storeOpenOptions[0] && components.includes('memberlevel') && isMemberLevelEnabled
      },
    },

    {
      title: 'SPA介紹',
      icon: '',
      type: 'link',
      to: {
        name: 'spa'
      }
    },
    /* {
      title: '開幕茶會',
      icon: '',
      type: 'link',
      to: {
        name: 'opening-reception'
      }
    }, */
    {
      title: currentMerchant.depositSetting?.title || '線上儲值',
      to: {
        name: 'deposit'
      },
      condition: () => {
        return !!storeOpenOptions[0] && components.includes('deposit') && hasDepositModule
      },
      isLoginPage: true,
    },
  ]);
}
//  dingbeauty 主選單
export function dingBeautyMainMenuList() {
  // const isSiteEnabled = store.getters['merchant/isSiteEnabled'];
  const currentMerchant = store.state.merchant.currentMerchant;
  const components = currentMerchant.components;
  const isPrepaidEnabled = !!currentMerchant.prepaidSetting?.isEnabled ?? false;
  const hasDepositModule = !!currentMerchant.depositSetting?.isEnabled ?? false;
  const isMemberLevelEnabled = !!currentMerchant.levelSetting?.isEnabled ?? false;
  const storeOpenOptions = storeOptions({
    type: 'open'
  });

  return conditionList([
    {
      title: '預約服務',
      type: 'lightbox',
      data: 'store',
      condition: () => {
        return !!storeOpenOptions[0] && !!currentMerchant.petCategories[0] 
      },
    },
    {
      title: currentMerchant.prepaidSetting?.title ||'套裝療程',
      icon: '',
      type: 'link',
      to: {
        name: 'prepaid'
      },
      condition: () => {
        return !!storeOpenOptions[0] && !!currentMerchant.petCategories[0] && isPrepaidEnabled
      },
    },
    {
      title: '護理介紹',
      icon: '',
      type: 'link',
      to: {
        name: 'spa'
      },
      condition: () => {
        return !!storeOpenOptions[0] && !!currentMerchant.petCategories[0] 
      },
    }, 
    {
      title: currentMerchant.depositSetting?.title || '線上儲值',
      to: {
        name: 'deposit'
      },
      condition: () => {
        return !!storeOpenOptions[0] && components.includes('deposit') && hasDepositModule
      },
      isLoginPage: true,
    },
    {
      title: currentMerchant.levelSetting?.title || '會員等級',
      to: {
        name: 'level'
      },
      condition: () => {
        return !!storeOpenOptions[0] && components.includes('memberlevel') && isMemberLevelEnabled
      },
    },

  ]);
}
export function jtailsMainMenuRightList() {
  const isLoggedIn = store.getters['auth/isLoggedIn'];

  return conditionList([
    {
      title: '',
      type: 'search',
      icon: 'fal fa-search',
    },
    {
      title: '結帳預約',
      type: 'cart',
      icon: 'fontello fontello-time',
      to: {
        name: 'reservation-checkout'
      },
    },
    {
      title: '線上購物',
      type: 'a',
      // icon: 'fontello fontello-shopping-bag',
      icon: 'fal fa-shopping-bag',
      href: window.globalData.APP_SHOP_URL,
      target: '_blank'
    },
    {
      title: '登入/註冊',
      type: 'login',
      icon: 'fal fa-user-circle',
      condition: () => {
        return !isLoggedIn
      },
    },
    {
      title: '',
      type: 'member',
      icon: 'fas fa-user-circle',
      to: {
        name: 'member'
      },
      condition: () => {
        return isLoggedIn
      },
    },
  ]);
}

//  dingbeauty 右側選單
export function dingbeautyMainMenuRightList() {
  const isLoggedIn = store.getters['auth/isLoggedIn'];

  return conditionList([
    {
      title: '預約中的服務',
      type: 'cart',
      icon: 'fontello fontello-time',
      to: {
        name: 'reservation-checkout'
      },
    },
    {
      title: '登入/註冊',
      type: 'login',
      icon: 'fal fa-user-circle',
      condition: () => {
        return !isLoggedIn
      },
    },
    {
      title: '',
      type: 'member',
      icon: 'fas fa-user-circle',
      to: {
        name: 'member'
      },
      condition: () => {
        return isLoggedIn
      },
    },
  ]);
}

export function jtailsMainMenuShopList() {
  const shopUrl = window.globalData.APP_SHOP_URL
  return conditionList([
    {
      title: '折扣專區',
      url: `${shopUrl}sale-corner`,
    },
    {
      title: '狗狗專區',
      url: `${shopUrl}dogs-corner`,
      // children: [
      //   {
      //     title: '狗狗食品',
      //     url: `${shopUrl}shop`,
      //   },
      //   {
      //     title: '狗狗用品',
      //     url: `${shopUrl}shop`,
      //   }
      // ]
    },
    {
      title: '貓咪專區',
      url: `${shopUrl}cats-corner`,
    },
    {
      title: '品牌專區',
      url: `${shopUrl}brand_jtails`,
    },
    {
      title: '獨家選品',
      url: `${shopUrl}pawoof-drinking-fountain`,
    },
    {
      title: '最新消息',
      url: `${shopUrl}news`,
    },
    // {
    //   title: '捲粉開箱',
    //   url: `${shopUrl}fans-unboxing`,
    // },
    {
      title: '門市資訊',
      url: `${shopUrl}stores`,
    },
    // {
    //   title: '團購專區',
    //   url: `${shopUrl}shop`,
    // },
    // {
    //   title: '線上購物',
    //   url: `${shopUrl}shop`,
    // },
  ]);
}

export function jtailsMainMenuRightShopList() {
  const isLoggedIn = store.getters['auth/isLoggedIn'];

  return conditionList([
    {
      title: '',
      type: 'search',
      icon: 'fontello fontello-search',
    },
    {
      title: '',
      type: 'cart',
      icon: 'fontello fontello-shopping-bag',
      href: window.globalData.APP_SHOP_URL,
      target: '_blank'
    },
    {
      title: '',
      type: 'login',
      icon: 'fontello fontello-user',
      condition: () => {
        return !isLoggedIn
      },
    },
    {
      title: '',
      type: 'link',
      icon: 'fontello fontello-user',
      to: {
        name: 'shop-member'
      },
      condition: () => {
        return isLoggedIn
      },
    },
  ]);
}

export function memberMenuList() {
  const currentMerchant = store.state.merchant.currentMerchant;
  const components = currentMerchant.components;
  // const hasDepositModule = !!currentMerchant.depositSetting?.isEnabled ?? false;
  return conditionList([
    {
      title: '預約/商品記錄',
      icon: 'appointment',
      to: {
        name: 'member-reservation'
      }
    },
    {
      title: currentMerchant.prepaidSetting?.title ||'包套方案',
      icon: 'plan',
      to: {
        name: 'member-prepaid'
      }
    },
    {
      title: '儲值金',
      icon: 'fal fa-usd-circle',
      isFontAwesome: true,
      to: {
        name: 'member-deposit'
      },
      condition: () => {
        return !!components.includes('deposit')
      },
    },
    {
      title: '會員設定',
      icon: 'user',
      to: {
        name: 'member-info'
      }
    },
    {
      title: '寵物資料',
      icon: 'paw',
      to: {
        name: 'member-pet'
      }
    }
  ]);
}

export function memberMenuListJtails() {
  const currentMerchant = store.state.merchant.currentMerchant;
  const components = currentMerchant.components;
  // const hasDepositModule = !!currentMerchant.depositSetting?.isEnabled ?? false;
  return conditionList([
    {
      title: '會員設定',
      icon: 'user',
      to: {
        name: 'member-info'
      }
    },
    {
      title: '預約/商品記錄',
      icon: 'appointment',
      to: {
        name: 'member-reservation'
      }
    },
    {
      title: currentMerchant.prepaidSetting?.title || process.env.VUE_APP_MODE === 'jtails' ? '包套方案': '套裝療程',
      icon: 'plan',
      to: {
        name: 'member-prepaid'
      }
    },
    {
      title: '儲值金',
      icon: 'fal fa-usd-circle',
      isFontAwesome: true,
      to: {
        name: 'member-deposit'
      },
      condition: () => {
        return !!components.includes('deposit')
      },
    },
    {
      title: '寵物資料',
      icon: 'paw',
      to: {
        name: 'member-pet'
      },
      condition: () => {
        return process.env.VUE_APP_MODE === 'jtails'
      },
    },
    {
      title: '使用人資料',
      icon: 'db-lipstick',
      to: {
        name: 'member-pet'
      },
      condition: () => {
        return process.env.VUE_APP_MODE === 'dingbeauty'
      },
    }
  ]);
}

export function memberMenuListJtailsShop() {
  return conditionList([
    {
      title: '會員設定',
      icon: 'account',
      to: {
        name: 'shop-member-info'
      }
    },
    {
      title: '消費累計',
      icon: 'appointment',
      to: {
        name: 'shop-member-shopping'
      }
    },
    {
      title: '捲粉點數',
      icon: 'paw',
      to: {
        name: 'shop-member-point'
      }
    },
    {
      title: '折價券',
      icon: 'coupon',
      to: {
        name: 'shop-member-coupon'
      }
    },
  ]);
}

export function termsMenuList() {
  return conditionList([
    {
      title: '使用細則＆隱私權條款',
      to: {
        name: 'privacy'
      },
    },
  ]);
}

export function serviceMenuList() {
  const isSiteEnabled = store.getters['merchant/isSiteEnabled'];
  const currentMerchant = store.state.merchant.currentMerchant;
  const components = currentMerchant.components;
  const isPrepaidEnabled = !!currentMerchant.prepaidSetting?.isEnabled ?? false;
  const hasDepositModule = !!currentMerchant.depositSetting?.isEnabled ?? false;
  const categoryAllOptions = categoryOptions();
  const storeOpenOptions = storeOptions({
    type: 'open'
  });

  return conditionList([
    {
      title: process.env.VUE_APP_MODE === 'dingbeauty' ? '線上預約': '店面服務',
      icon: 'fontello fontello-shop',
      type: 'lightbox',
      data: 'store',
      condition: () => {
        return (process.env.VUE_APP_MODE === 'jtails' || process.env.VUE_APP_MODE === 'dingbeauty') && !!storeOpenOptions[0] && !!currentMerchant.petCategories[0] 
      },
    },
    {
      title: '到府服務',
      icon: 'fontello fontello-house',
      type: 'lightbox',
      data: 'home',
      condition: () => {
        return process.env.VUE_APP_MODE === 'jtails' && !!storeOpenOptions[0] && !!currentMerchant.petCategories[0] 
      },
    },
    {
      title: currentMerchant.cosmeticSetting.title || '線上預約',
      to: {
        name: 'reservation',
      },
      condition: () => {
        return process.env.VUE_APP_MODE === 'ipetbooking' && !!storeOpenOptions[0] && !!categoryAllOptions[0] && isSiteEnabled
      },
    },
    {
      title: currentMerchant.prepaidSetting?.title || process.env.VUE_APP_MODE === 'dingbeauty' ? '套裝療程': '包套服務',
      to: {
        name: 'prepaid',
      },
      condition: () => {
        return !!storeOpenOptions[0] && !!categoryAllOptions[0] && isPrepaidEnabled
      },
    },
    {
      title: currentMerchant.depositSetting?.title || '線上儲值',
      to: {
        name: 'deposit'
      },
      condition: () => {
        return !!storeOpenOptions[0] && !!currentMerchant.petCategories[0] && components.includes('deposit') && hasDepositModule
      },
      isLoginPage: true,
    },
    {
      title: '線上購物<i class="fal fa-external-link ml-2 fs-2sm"></i>',
      href: window.globalData.APP_SHOP_URL,
      condition: () => {
        return process.env.VUE_APP_MODE === 'jtails'
      },
    },
  ])
}
